import parseFileName from 'common/src/utils/fileUtils/parseFileName';
import {getAllKnownExtensions} from 'common/src/modules/Assets/utils/assetTypeMapping';

const supportedExtensions = new Set(getAllKnownExtensions().map((extension) => extension.toLowerCase()));

type NormalizedFileNameResult =
  | {
      normalizedFileName: string;
    }
  | {
      errorMessage: string;
    };

export default function normalizeAndValidateAssetFileName(
  fileName: string,
): NormalizedFileNameResult {
  const {fileExtension, fileNameWithoutExtension} = parseFileName(fileName);
  const normalizedExtension = fileExtension?.toLowerCase() ?? '';

  if (!normalizedExtension) {
    return {
      errorMessage: `File "${fileName}" has no extension. Please use a supported file type.`,
    };
  }

  if (!supportedExtensions.has(normalizedExtension)) {
    return {
      errorMessage: `Unsupported file extension ".${normalizedExtension}" for "${fileName}".`,
    };
  }

  return {normalizedFileName: `${fileNameWithoutExtension}.${normalizedExtension}`};
}
